import { FigmaTypography } from "@libs/zapi-ui/custom";

export function ReleaseBanner() {
  const bannerMessage = import.meta.env.VITE_RELEASE_BANNER;

  if (!bannerMessage) return null;

  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 px-4 py-3 flex items-center justify-between">
      <div className="flex items-center gap-2">
        <FigmaTypography variant="body-2" className="text-yellow-800">
          {bannerMessage}
        </FigmaTypography>
      </div>
    </div>
  );
}
